import { action } from "@ember/object"
import Component from "@glimmer/component"

interface Args {
  onSelect: Function
}

export default class SimpleSelect extends Component<Args> {
  @action
  handlePressKey(e, sb) {
    sb.activateOptionForKeyCode(e.keyCode)

    if (!sb.isOpen) {
      sb.selectActiveOption()
    }
  }

  @action
  handlePressUp(e, sb) {
    e.preventDefault()
    sb.activatePreviousOption()
  }

  @action
  handlePressDown(e, sb) {
    e.preventDefault()
    sb.activateNextOption()
    sb.open()
  }

  @action
  close(e, sb) {
    sb.close()
  }

  @action
  select(value, sb) {
    this.args.onSelect(value)
    sb.close()
  }
}
